import React from 'react'

const AboutSection = () => {
  return (
    <div className='container about-container'>
      <div className='about-content-div'>
          <img className='about-image' src="/assets/images/about-cargo.png" alt="" />
        <div className='about-right' >
          <h4 className='text-uppercase my-4 Ethnocentric'>We are bluedart express dubai</h4>
          <p className=''>
            Blue Dart Express Dubai is leading the shift towards sustainable logistics.
             We specialize in eco-friendly shipping solutions that reduce environmental impact while maximizing efficiency. More than just packages, we deliver emotions — with care, responsibility, and 24/7 Operational Exellence. Proudly, we deliver The World On Time.
          </p>  
        </div>
      </div>
    </div>
  )
}

export default AboutSection